<script>
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';

  let messages = [
    { text: "O sucesso é a soma de pequenos esforços repetidos dia após dia.", author: "Robert Collier" },
    { text: "A única maneira de fazer um grande trabalho é amar o que você faz.", author: "Steve Jobs" },
    { text: "Você perde 100% dos tiros que não dá.", author: "Wayne Gretzky" },
    { text: "A dor que você sente hoje será a força que você sentirá amanhã.", author: "Anônimo" },
    { text: "Não importa o quão devagar você vá, desde que você não pare.", author: "Confúcio" },
  ];

  let currentMessage = messages[0];
  let index = 0;
  let show = true;

  function showNextMessage() {
    show = false;
    setTimeout(() => {
      index = (index + 1) % messages.length;
      currentMessage = messages[index];
      show = true;
    }, 1000); // Tempo para o fade-out
  }

  onMount(() => {
    const interval = setInterval(showNextMessage, 5000);
    return () => clearInterval(interval);
  });
</script>

<style>
  .motivacional {
    font-family: 'Roboto Slab', serif;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-image:  url('/img/fundomotivacional.png');
    background-size: cover;
    background-position: center;
    color: white;
    text-align: center;
    padding: 20px;
  }

  .message {
    transition: opacity 1s, transform 1s;
    opacity: 0;
    transform: translateX(-100%);
  }

  .message.show {
    opacity: 1;
    transform: translateX(0);
  }

  .author {
    margin-top: 10px;
    font-weight: bold;
  }
</style>

<div class="motivacional">

  {#if show}
    <div class="message show" in:fade={{ duration: 1000 }} out:fade={{ duration: 1000 }}>
      <p>{currentMessage.text}</p>
      <div class="author">- {currentMessage.author}</div>
    </div>
  {/if}
</div>
